// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__3IzEB","cardContainerList":"style_cardContainerList__319kX","marginVertical":"style_marginVertical__OMqkb"};